import React, { Component } from 'react';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import { VesselsApi } from '_legacy/api/vesselsApi';
import FortDownshiftInput from '../../../../components/grid/inputs/FortDownshiftInput';
import { Slider } from 'react-semantic-ui-range';
import VesselCapacityFormatter from '../formatters/VesselDwtFormatter';
import { getVesselPostProcessingService } from '../services/VesselPostProcessingServiceFactory';
import * as layoutActions from '_legacy/actions/layoutActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { gasDatasetIds, getDataset } from '_legacy/models/Datasets';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { changeGridSettings } from 'store/feature/layoutsSlice';

class VesselSelect extends Component {
    constructor(props) {
        super(props);

        this.inputRef = React.createRef();
        this.handleItemSelected = this.handleItemSelected.bind(this);
        this.setMultipleValues = this.setMultipleValues.bind(this);
        this.search = this.search.bind(this);

        this.state = {
            isSearching: false,
        };

        const { allowSearchVesselsByEniNumber } = getDataset(
            this.props.context.datasetId
        );
        this.vesselSearchPlaceholder = allowSearchVesselsByEniNumber
            ? 'Enter vessel name or IMO or ENI'
            : 'Enter vessel name or IMO';
    }

    itemToString = (item) => {
        return isNil(item) || isNil(item.name) ? '' : item.name;
    };

    handleItemSelected(selectedVessel, keyCode, shift) {
        if (this.props.onVesselSelected) {
            const vessel = this.convertRetrievedVessel(selectedVessel);
            const { searchVesselsWithImoOnly } = getDataset(
                this.props.context.datasetId
            );

            if (searchVesselsWithImoOnly && !vessel.imo) {
                this.props.onVesselSelected(null, keyCode, shift);
                return;
            }

            return this.doVesselPostProcessing(vessel, keyCode, shift);
        }
    }

    handlePlaceholderEntered = (placeholder, keyCode, shift) => {
        const vessel = this.createTbnVessel();

        return this.doVesselPostProcessing(vessel, keyCode, shift);
    };

    doVesselPostProcessing = (vessel, keyCode, shift) => {
        const service = getVesselPostProcessingService(
            this.props.context.datasetId
        );

        if (service) {
            vessel.shouldUpdateOwner = true;

            if (service.shouldShowOwnerConfirmationWindow(this.props, vessel)) {
                service.showOwnerConfirmationDialog(
                    this.props,
                    vessel,
                    keyCode,
                    shift
                );
                return;
            }
        }

        this.props.onVesselSelected(vessel, keyCode, shift);
    };

    convertRetrievedVessel(vessel) {
        return {
            vesselId: vessel.vesselId,
            imo: vessel.imo,
            eniNumber: vessel.eniNumber,
            shipsBaseTankerVesselId: vessel.shipsBaseTankerVesselId,
            name: vessel.name.toUpperCase(),
            scrubber: vessel.scrubber,
            yard: vessel.yard,
            dwt: vessel.dwt,
            tankTypeCode: vessel.tankTypeCode,
            gasCbm: vessel.gasCbm,
            yob: vessel.yob,
            design: vessel.design,
            imoClass: vessel.imoClass
                ? {
                      imoGradeI: vessel.imoClass.imoGradeI,
                      imoGradeII: vessel.imoClass.imoGradeII,
                      imoGradeIII: vessel.imoClass.imoGradeIII,
                  }
                : null,
            iceClassNotation: vessel.iceClassNotation,
            grades: vessel.grades,
            nitrogenPlant: vessel.nitrogenPlant,
            bestOperator: vessel.bestOperator,
            gainCompany: vessel.gainCompany
                ? {
                      value: vessel.gainCompany.value,
                      partType: vessel.gainCompany.partType,
                      name: vessel.gainCompany.name,
                  }
                : null,
            fleetTypeIds: vessel.fleetTypeIds,
            gasType: vessel.gasType,
            engineType: vessel.engineType,
            propType: vessel.propType,
            isTbn: false,
            builtDate: vessel.builtDate,
            alternativeFuelType: vessel.alternativeFuelType,
        };
    }

    createCustomVessel(value) {
        return {
            vesselId: null,
            imo: null,
            eniNumber: null,
            shipsBaseTankerVesselId: null,
            dwt: null,
            tankTypeCode: null,
            gasCbm: null,
            scrubber: null,
            yard: null,
            design: null,
            imoClass: null,
            iceClassNotation: null,
            grades: null,
            nitrogenPlant: null,
            name: value.toUpperCase(),
            yob: null,
            isTbn: false,
            gasType: null,
            engineType: null,
            propType: null,
            alternativeFuelType: null,
        };
    }

    createTbnVessel() {
        return {
            vesselId: null,
            imo: null,
            eniNumber: null,
            shipsBaseTankerVesselId: null,
            name: 'TBN',
            scrubber: null,
            yard: null,
            design: null,
            imoClass: null,
            iceClassNotation: null,
            grades: null,
            nitrogenPlant: null,
            dwt: null,
            tankTypeCode: null,
            gasCbm: null,
            yob: null,
            isTbn: true,
            gasType: null,
            engineType: null,
            propType: null,
            alternativeFuelType: null,
        };
    }

    focus() {
        if (this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    renderVessel(
        getItemProps,
        highlightedIndex,
        vessel,
        index,
        length,
        disalowFreeTextVessel,
        allowSearchVesselsByEniNumber,
        datasetId
    ) {
        const imoEniDisplayValue = vessel.imo
            ? vessel.imo
            : allowSearchVesselsByEniNumber && vessel.eniNumber
            ? `${vessel.eniNumber}*`
            : '-';

        const isGasDataset = gasDatasetIds.includes(datasetId);

        return disalowFreeTextVessel && length === 1 && vessel.key ? (
            <tr key={vessel.key}>
                <td
                    colSpan={4}
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}
                >
                    <span>Unable to find any matching Vessel</span>
                </td>
            </tr>
        ) : (
            ((disalowFreeTextVessel && !vessel.key) ||
                !disalowFreeTextVessel) && (
                <tr
                    {...getItemProps({
                        item: vessel,
                        key: vessel.vesselId || vessel.key,
                        style: {
                            backgroundColor:
                                highlightedIndex === index
                                    ? 'rgba(0,0,0,0.05)'
                                    : 'white',
                        },
                    })}
                >
                    <td>
                        {vessel.key && !disalowFreeTextVessel ? (
                            <span>ADD: "{vessel.name}"</span>
                        ) : (
                            <span>{imoEniDisplayValue}</span>
                        )}
                    </td>
                    <td> {!vessel.key && <span>{vessel.name}</span>}</td>
                    {isGasDataset ? (
                        <td>
                            {vessel.gasCbm && (
                                <span>
                                    {VesselCapacityFormatter({
                                        value: vessel.gasCbm,
                                    })}
                                </span>
                            )}
                        </td>
                    ) : (
                        <td>
                            {vessel.dwt && (
                                <span>
                                    {VesselCapacityFormatter({
                                        value: vessel.dwt,
                                    })}
                                </span>
                            )}
                        </td>
                    )}
                    <td> {vessel.yob && <span>{vessel.yob}</span>}</td>
                </tr>
            )
        );
    }

    renderVesselHeader(allowSearchVesselsByEniNumber, datasetId) {
        const header = allowSearchVesselsByEniNumber ? 'IMO/ENI*' : 'IMO';
        const capacityHeader = gasDatasetIds.includes(datasetId)
            ? 'CBM'
            : 'DWT';

        return (
            <thead>
                <tr>
                    {allowSearchVesselsByEniNumber ? (
                        <Tooltip
                            placement="top"
                            overlay="Barge's ENI are denoted by an * in the column below"
                        >
                            <th>{header}</th>
                        </Tooltip>
                    ) : (
                        <th>{header}</th>
                    )}
                    <th>Name</th>
                    <th>{capacityHeader}</th>
                    <th>YOB</th>
                </tr>
            </thead>
        );
    }

    updateFixtureLayout(values) {
        this.props.dispatch(
            changeGridSettings({
                gridType: 'fixtures',
                gridSettings: {
                    vesselOptions: {
                        minCapacity: values[0],
                        maxCapacity: values[1],
                    },
                },
            })
        );
    }

    setMultipleValues(values) {
        this.updateFixtureLayout(values);
        this.inputRef.current.onFilterChanged();
    }

    search(query, cancelToken) {
        const { searchVesselsWithImoOnly } = getDataset(
            this.props.context.datasetId
        );
        this.setState({ isSearching: true });

        return VesselsApi.searchVessel(
            query,
            this.props.context.datasetId,
            this.props.minCapacity * 1000,
            this.props.maxCapacity * 1000,
            searchVesselsWithImoOnly,
            cancelToken
        );
    }

    render() {
        const sizeOfFilter = 77;
        const settings = {
            start: [this.props.minCapacity, this.props.maxCapacity],
            min: 0,
            max: 750,
            step: 10,
            onChange: (value) => {
                this.setMultipleValues(value);
            },
        };
        const { searchVesselsWithImoOnly, allowSearchVesselsByEniNumber } =
            getDataset(this.props.context.datasetId);

        const filter = (
            <div className="downshift-filter">
                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '50%' }}>
                                <label className="ui label">
                                    {this.props.minCapacity * 1000}
                                </label>
                            </td>
                            <td style={{ width: '50%', textAlign: 'right' }}>
                                <label className="ui label">
                                    {this.props.maxCapacity * 1000}
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ marginTop: '10px' }}>
                    <Slider multiple={true} color="blue" settings={settings} />
                </div>
            </div>
        );

        return (
            <FortDownshiftInput
                {...this.props}
                className="vesselSelect"
                ref={this.inputRef}
                itemToString={this.itemToString}
                searchFunc={this.search}
                renderTableHeader={() =>
                    this.renderVesselHeader(
                        allowSearchVesselsByEniNumber,
                        this.props.context.datasetId
                    )
                }
                renderItem={({
                    getItemProps,
                    highlightedIndex,
                    item,
                    index,
                    totalCount,
                }) =>
                    this.renderVessel(
                        getItemProps,
                        highlightedIndex,
                        item,
                        index,
                        totalCount,
                        searchVesselsWithImoOnly,
                        allowSearchVesselsByEniNumber,
                        this.props.context.datasetId
                    )
                }
                placeholder={this.vesselSearchPlaceholder}
                createCustomItem={this.createCustomVessel}
                onItemSelected={this.handleItemSelected}
                placeholderTerms={['TBN']}
                onPlaceholderEntered={this.handlePlaceholderEntered}
                sizeProps={{ additionalComponentSize: sizeOfFilter }}
            >
                {this.state.isSearching && filter}
            </FortDownshiftInput>
        );
    }
}

VesselSelect.propTypes = {
    onVesselSelected: PropTypes.func.isRequired,
    shouldSelectItemOnTab: PropTypes.bool.isRequired,
    inputClass: PropTypes.string,
    onTab: PropTypes.func.isRequired,
    onTabBack: PropTypes.func.isRequired,
    onEnter: PropTypes.func.isRequired,
    initialChar: PropTypes.string,
    onInputCleared: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const fixturesOptions =
        state.layouts.selectedLayout.fixtures.currentOptions;

    const props = {
        fixturesOptions: fixturesOptions,
        minCapacity: fixturesOptions.vesselOptions.minCapacity,
        maxCapacity: fixturesOptions.vesselOptions.maxCapacity,
    };

    return props;
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...layoutActions }, dispatch),
        dispatch,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(VesselSelect);
